import {
  Box,
  Button,
  IconButton,
  InputLabel,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { labels } from "../../data/constants";
import { useEffect, useState } from "react";
import { editWorkspaceName, listWorkspace } from "../../Services/WorkspaceService";
import { useDispatch } from "react-redux";
import { logChanges } from "../../Services/commentService";

const EditWorkspace = ({ open, setOpen, userWorkspace }) => {
  const style = {
    position: "absolute",
    top: "30%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: "8px",
    boxShadow: 24,
    p: 4,
  };
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState(userWorkspace?.name);
  useEffect(() => {
    setInputValue(userWorkspace?.name)
  }, [userWorkspace])
  const handleClose = () => setOpen(false);
  const handleInputChange = (e) => {
    if (e.target.value?.length > 50) {
      return;
    }
    setInputValue(e.target.value);
  }
  const handleUpdateWorkspace = async () => {
    try {
      const payload = {
        workspaceId: userWorkspace.id,
        workspaceName: inputValue
      }
      await editWorkspaceName(payload, dispatch);
      const resp = await listWorkspace(dispatch);
      handleClose();
      let changeLogPayload = {
        changeDetail: `Workspace name changed to '${inputValue}'`,
        workspaceId: userWorkspace.id
      }
      await logChanges(changeLogPayload, dispatch);
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>
        <Box mb={2}>
          <Typography variant="dashboardCompHeading2">
            {labels.workspace.updateWorkspaceLabel}
          </Typography>
        </Box>
        <InputLabel required className="dashboardLabel1 fontWeight500">
          {labels.workspace.workspaceNameInputLabel}
        </InputLabel>
        <TextField
          fullWidth
          className="textFieldType3"
          placeholder={labels.businessIdeas.addIdeaModal.namePlaceholder}
          value={inputValue}
          onChange={handleInputChange}
        />
        <Box mt={2} display="flex" justifyContent="space-between" gap={2}>
          <Button
            variant="outlined"
            sx={{
              color: "rgb(25, 62, 135)",
              borderColor: "rgb(25, 62, 135)",
              "&:hover": {
                borderColor: "rgb(25, 62, 135)",
                backgroundColor: "rgb(46 47 255 / 4%)",
              },
            }}
            className="textTransformNone"
            onClick={handleClose}
          >
            {labels.workspace.cancelButtonLabel}
          </Button>
          <Button variant="buttonVariant1" className="textTransformNone" onClick={handleUpdateWorkspace}>
            {labels.workspace.updateWorkspaceLabel}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditWorkspace;
